
const Empresa: React.FC = () => {
    return (
        <ul className="space-y-1 text-base leading-7">
            <li className="flex items-center">
                <span className="mr-2">•</span>
                <span><strong>Nombre de la Empresa:</strong> CuadraNex S.L</span>
            </li>
            <li className="flex items-center">
                <span className="mr-2">•</span>
                <span><strong>CIF:</strong> B-26925339</span>
            </li>
            <li className="flex items-center">
                <span className="mr-2">•</span>
                <span><strong>Calle:</strong> Oropesa nº 11</span>
            </li>
            <li className="flex items-center">
                <span className="mr-2">•</span>
                <span><strong>Localidad:</strong> Yuncos</span>
            </li>
            <li className="flex items-center">
                <span className="mr-2">•</span>
                <span><strong>Provincia:</strong> Toledo</span>
            </li>
            <li className="flex items-center">
                <span className="mr-2">•</span>
                <span><strong>Código Postal:</strong> 45210</span>
            </li>
            <li className="flex items-center">
                <span className="mr-2">•</span>
                <span><strong>Teléfono:</strong> +34 (925 004 105 - 671 562 558)</span>
            </li>
              <li className="flex items-center">
                <span className="mr-2">•</span>
                <span><strong>Email:</strong> contacto@linkservs.com</span>
            </li>
        </ul>
    );
};

export default Empresa;
